'use client';

import React from 'react';
import Image from 'next/image';
import { X, Phone } from 'lucide-react';
import { Button } from './Button';
import { cn } from '@/lib/utils';
import { Product } from '@/types'; // Product tipini import et
import Link from 'next/link';

interface ProductDetailModalProps {
  product: Product | null; // Gösterilecek ürün verisi, null olabilir
  onClose: () => void; // Modalı kapatma fonksiyonu
}

const ProductDetailModal = ({ product, onClose }: ProductDetailModalProps) => {
  // Eğer ürün verisi yoksa veya modal kapalıysa bir şey render etme
  if (!product) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm overflow-y-auto p-4 animate-fade-in">
      {/* Modal İçeriği */}
      <div className="relative bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto animate-slide-up">
        {/* Kapatma Butonu */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 p-2 rounded-full bg-white/80 text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition"
          aria-label="Modali kapat"
        >
          <X size={20} />
        </button>

        {/* Modal Body */}
        <div className="p-6 md:p-8">
          {/* Ürün Görseli (İlk görseli alıyoruz) */}
          {product.images && product.images.length > 0 && (
            <div className="relative w-full h-64 md:h-80 min-h-[256px] aspect-square rounded-lg overflow-hidden mb-6">
              <Image
                src={product.images[0]}
                alt={product.name?.trim() || 'Filiz Kozmetik ürün görseli'}
                fill
                sizes="(max-width: 768px) 100vw, 50vw"
                className="object-cover"
              />
            </div>
          )}

          {/* Ürün Bilgileri */}
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            {product.name}
          </h3>

          {/* Kategori ve Fiyat (Eğer varsa) */}
          <div className="flex items-center gap-4 mb-4 text-gray-600 text-sm">
            {product.category && <span>Kategori: {product.category}</span>}
            {product.price !== undefined && product.price > 0 && (
               <span className="font-semibold text-primary">Fiyat: Sorunuz</span> /* Fiyat gösterimi kaldırıldı */
            )}
             {/* Daha önce fiyatin 0 gelmesi durumu vardi, fiyati direkt olarak "Fiyat: Sorunuz" olarak gösterelim */}
          </div>

          {/* Açıklama */}
          {product.description && (
            <div className="mb-6">
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Açıklama</h4>
              <p className="text-gray-600 leading-relaxed">
                {product.description}
              </p>
            </div>
          )}

          {/* Özellikler */}
          {product.features && product.features.length > 0 && (
            <div className="mb-6">
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Özellikler</h4>
              <ul className="list-disc list-inside text-gray-600">
                {product.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Aksiyon Butonları (Örn: Teklif Al) */}
          <div className="flex justify-end">
             <Link href="/iletisim">
               <Button className="bg-primary text-white hover:bg-primary-dark text-lg">
                 <Phone size={18} className="mr-2"/>
                 Teklif Al / Fiyat Sor
               </Button>
             </Link>
           </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailModal; 